<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-17 09:35:41
 * @Description: 标记列表
 * @LastEditors: Please set LastEditors
-->
<template>
  <div>
    <div
      class="p-10 w-100 h-100 position-absolute"
      id="marker_list"
      :style="{ height: height, top: top }"
    >
      <el-card>
        <div slot="header" class="business_dialog_title text-color-white m-b-5">
          <span class="fz-14">标记列表</span>
          <span class="iconfont icon-close cur-pointer r close_icon" @click="closeDialog"></span>
        </div>
        <el-tree
          :data="treeData"
          :props="defaultProps"
          @node-click="handleNodeClick"
          default-expand-all
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="data.level != 1">
              <el-tooltip content="查看" placement="top" effect="dark" :open-delay="1000">
                <el-button
                  type="info"
                  icon="el-icon-view"
                  @click.stop="showMarker(data)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top" effect="dark" :open-delay="1000">
                <el-button
                  v-if="data.canDelete === 1"
                  type="danger"
                  icon="el-icon-delete"
                  @click.stop="removeMarker(data)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="分享" placement="top" effect="dark" :open-delay="1000">
                <el-button
                  class="el-icon-share"
                  type="primary"
                  @click.stop="shareMarker(data)"
                ></el-button>
              </el-tooltip>
            </span>
          </span>
        </el-tree>
      </el-card>
    </div>
    <!-- 分享标记弹框 -->
    <saveOrShareMarker
      v-if="showShareDialog"
      :title="componentTitle"
      :right="'410px'"
      :disableName="true"
      :formLabelAlign="formLabelAlign"
      @closeComponents="closeShareDialog"
    ></saveOrShareMarker>
  </div>
</template>

<script>
import DocumentManagementService from '@/services/documentManagement'
import Marker from '@/services/marker'

const saveOrShareMarker = () => {
  return import('./photoEdit/saveOrShareMarker')
}
export default {
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    currentModel: {
      type: Object,
      default: () => {
        return {}
      },
    },
    currentSplitFileId: {
      // 如果分屏文件id有，那么该二维列表就是从分屏那边点击过来的， 否则就是模型tool点击的
      // 当前分屏的fileId
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    top: {
      type: String,
      default: '',
    },
  },
  components: {
    saveOrShareMarker,
  },
  watch: {
    currentModel: {
      handler(val) {
        this.getMarkerList()
      },
      deep: true,
    },
    currentSplitFileId(val) {
      if (val) {
        this.getMarkerList()
      }
    },
  },
  data() {
    return {
      activeName: 'markerList',
      treeData: [
        {
          level: 1,
          label: '我的标记',
          children: [],
        },
        {
          level: 1,
          label: '别人分享的标记',
          children: [],
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      formLabelAlign: {},
      componentTitle: '分享标记',
      showShareDialog: false,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  created() {
    // 获取标记列表
    this.getMarkerList()
  },
  methods: {
    /**
     * @description: 获取标记列表
     * @param {*}
     * @return {*}
     */

    async getMarkerList() {
      const query = {
        siteid: this.currentProject ? this.currentProject.id : ' ',
        pagesize: 999,
        pageno: 1,
        documentfileid: this.currentSplitFileId || this.currentModel.fileId,
      }
      this.treeData = this.$options.data().treeData
      const res = await Marker.getList(query)
      if (res && res.code === 0 && res.data) {
        _.forEach(res.data, (el) => {
          if (el.classify === 1) {
            // 我的标记
            this.treeData[0].children.push({
              label: el.name,
              ...el,
              level: 2,
            })
          } else {
            this.treeData[1].children.push({
              label: el.name,
              ...el,
              level: 2,
            })
          }
        })
      }
    },
    closeDialog() {
      this.$emit('closeComponent', 'MarkerList')
    },
    // 关闭分享弹框
    closeShareDialog() {
      this.showShareDialog = false
    },
    /**
     * @description: 打开分享弹框
     * @param {*} data
     * @return {*}
     */

    shareMarker(data) {
      this.formLabelAlign = {
        ...data,
      }
      this.showShareDialog = true
    },
    /**
     * @description: 删除标记
     * @param {*} data
     * @return {*}
     */

    removeMarker(data) {
      this.$confirm('此操作将永久删除该条标记, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await Marker.deleteMark([data.id])
          if (res && res.code === 0 && res.data) {
            this.$message.success('删除成功')
            this.getMarkerList()
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // tab点击事件
    handleClick(node) {},
    /**
     * @description: 标记查看
     * @param {*} node
     * @return {*}
     */

    showMarker(node) {
      this.handleNodeClick(node)
      // 切换为查看标记状态
      this.$emit('showMarker', node)
    },
    handleNodeClick(node) {
      const info = JSON.parse(node.cameraPosition)
      // 文件or模型定位
      if (node.cameraPosition) {
        if (node.markType === '2') {
          this.player.Native.Camera.moveTo(info.eye, info.target, info.up, 2)
        } else if (node.markType === '1') {
          // 文件定位
          this.$emit('changeFileLocation', info)
        }
      }
    },
    /**
     * @description: 跳转 查看详情
     * @param {*}
     * @return {*}
     */

    goPhotoEdit(data) {
      this.$router.push({
        name: 'photoEdit',
        params: {
          detail: data,
          type: 'showMark',
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/index.scss';
#marker_list {
  z-index: 99;
  width: 368px;
  right: 35px;
  border-radius: 2px;
  transition: left 0.3s;
  background-color: rgba(46, 107, 176, 0.5) !important;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding-right: 8px;
}
.close_icon {
  z-index: 1;
}
/deep/ .el-tabs {
  background-color: rgba(24, 41, 72, 0.5) !important;
  &__content {
    height: 88%;
    overflow: scroll;
  }
  .el-tabs__header {
    border-bottom: 1px solid #333;
  }
}
/deep/ .el-card {
  height: 100%;
  &__body,
  &__header {
    padding: 5px;
  }
  &__body {
    height: calc(100% - 30px);
    overflow-y: scroll;
    background-color: rgba(24, 41, 72, 0.5) !important;
  }
}

</style>
